import React, { useEffect, useState } from 'react';
import { find } from 'lodash';
import { Field } from 'formik';

import useAxios from 'hooks/useAxios';
import FormikSelectField from 'components/common/Fields/FormikSelectField';

const Plan = ({ onChange, ...rest }) => {
  const API = useAxios();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchPlanData = async () => {
    setLoading(true);
    try {
      const { data } = await API.post('/Plan/getPBMPlans', {
        pbmAPI: true,
      });
      setLoading(false);
      setData(data);

      if (data) {
        data.map((plan) => {
          plan.planDetails = `${plan.planCode}-${plan.planDesc}`;
        });
        if (rest.value) {
          if (rest.value) {
            const entity = find(data, {
              planID: parseInt(rest.value),
            });
            onChange(rest.value, entity);
          } else {
            onChange(rest.value, '');
          }
        }
      }
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlanData();
  }, []);
  const planData = loading ? [] : data || [];

  const handleChange = ({ target: { value } }) => {
    if (value) {
      const entity = find(planData, {
        pbmPlanID: parseInt(value),
      });
      onChange(value, entity);
    } else {
      onChange(value, '');
    }
  };
  return (
    <Field
      name='planName'
      type='text'
      component={FormikSelectField}
      options={planData}
      defaultoption='--Select--'
      className='required'
      keys={{
        id: 'pbmPlanID',
        label: 'planDetails',
      }}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default Plan;
